// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mh-0";
export var assigneeDetails = "_mh-1";
export var assigneeInfo = "_mh-2";
export var dropdownContainer = "_mh-4";
export var dropdownImage = "_mh-5";
export var editAssigneeInfo = "_mh-3";
export var editAssigneeModalContainer = "_mh-6";
export var hidden = "_mh-8";
export var input = "_mh-7";